import * as React from 'react';

// @ts-ignore
import Group from 'entities/Group';
// @ts-ignore
import Organization from 'entities/Organization';
// @ts-ignore
import * as GroupPromises from 'groups/lib/GroupPromises';

import NavigationListGroupItem from './NavigationListGroupItem';

import { NavigationList_me_navigationSections_items } from 'queries/__generated__/NavigationList';

type Props = {
  group: NavigationList_me_navigationSections_items;
};

type State = {
  district?: Organization | null;
};

export default class NavigationListDistrictGroupItem extends React.Component<Props, State> {
  state = {
    district: null,
  };

  async componentDidMount() {
    const { group } = this.props;
    if (group.__typename !== 'Class') {
      return;
    }

    const districtGroup = await GroupPromises.loadGroupByCode(group.name);
    if (districtGroup) {
      this.setDistrict(districtGroup);
    }
  }

  setDistrict = (group: Group) => {
    this.setState({ district: group.getOrganization() });
  };

  render() {
    return <NavigationListGroupItem group={this.props.group} district={this.state.district} />;
  }
}
